import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-630acbea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "BinaryChoice" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "buttonChoice" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "checkbox",
  disabled: ""
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "slider round" }, null, -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "checkbox",
  checked: "",
  disabled: ""
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "slider round" }, null, -1))
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      class: "picture",
      src: _ctx.answers[0].Picture ?? undefined,
      alt: _ctx.answers[0].Text ?? undefined
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("label", {
        class: _normalizeClass(["switch", { checked: _ctx.clickedAnswer === 0 }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.clickAnswer(0, '1')))
      }, _hoisted_6, 2),
      _createElementVNode("label", {
        class: _normalizeClass(["switch", { checked: _ctx.clickedAnswer === 1 }]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clickAnswer(1, '2')))
      }, _hoisted_9, 2)
    ])
  ]))
}